var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 9.01C6.52002 9.01 4.50002 6.99 4.50002 4.51C4.50002 2.03 6.52002 0 9.00002 0C11.48 0 13.5 2.02 13.5 4.5C13.5 6.98 11.48 9 9.00002 9V9.01ZM9.00002 1.5C7.34002 1.5 6.00002 2.85 6.00002 4.5C6.00002 6.15 7.35002 7.5 9.00002 7.5C10.65 7.5 12 6.15 12 4.5C12 2.85 10.65 1.5 9.00002 1.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 18H2.26001C1.85001 18 1.51001 17.66 1.51001 17.25C1.51001 13.12 4.87001 9.76 9.00001 9.76C13.13 9.76 16.49 13.12 16.49 17.25C16.49 17.66 16.15 18 15.74 18H15.75ZM3.06001 16.5H14.95C14.58 13.55 12.05 11.25 9.00001 11.25C5.95001 11.25 3.43001 13.55 3.06001 16.5Z",
    fill: "currentColor",
    className: "accent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3efb49c4cd01ec59196ad05e9c6f36c5.svg";
export { ForwardRef as ReactComponent };